export enum SelectedProductStatus {
    ACCEPTED = 'ACCEPTED',
    ACTIVE = 'ACTIVE',
    CANCELED = 'CANCELED',
    DRAFT = 'DRAFT',
    ERROR = 'ERROR',
    EXECUTED = 'EXECUTED',
    EXPIRED = 'EXPIRED',
    FOR_SIGNING = 'FOR_SIGNING',
    IN_PROCESS = 'INPROCESS',
    NON_SUCCESSFUL_SIGNATURE = 'NON SUCCESSFUL SIGNATURE',
    REJECTED = 'REJECTED',
}
